import type { CustomIconProps } from '../types';

const RevertedLikeFilled = ({ width, height }: CustomIconProps): JSX.Element => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width ?? '16'}
        height={height ?? '14'}
        viewBox="0 0 16 14"
        fill="none"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16 9.71333C16 12.0941 14.0866 14 11.6954 14C9.8293 14 8.74283 13.0028 8 12.1869C7.25717 13.0028 6.1707 14 4.30458 14C1.91339 14 1.66619e-07 12.0941 3.74753e-07 9.71333C4.98837e-07 8.29397 0.419728 7.14617 1.58724 5.74974C2.74693 4.36266 4.6523 2.72086 7.62915 0.307768L8 -6.99382e-07L8.3702 0.307243C11.3471 2.72033 13.2531 4.36266 14.4128 5.74974C15.5803 7.14618 16 8.29397 16 9.71333Z"
            fill="#414042"
        />
    </svg>
);

export default RevertedLikeFilled;
